import { useModalStore } from "@/hooks/Modal/hooks";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { CompanyLogTargetType, getCompanyLogs } from "@/services/api/companyLog";
import { usePagination } from "ahooks";
import { Button, Modal, Table } from "antd";
import { observer } from "mobx-react";
import React from "react";

interface LogButtonProps {
  shippingAddressId: number;
}

interface RecycleSettingModalProps extends InjectBaseModalProps, LogButtonProps {}

const RecycleSettingModal: React.FC<RecycleSettingModalProps> = function (props) {
  const { onCancel, visible, shippingAddressId } = props;

  const { data, loading, pagination } = usePagination(
    async ({ pageSize, current }) => {
      const result = await getCompanyLogs({
        pageNo: current,
        pageSize: pageSize,
        targetId: shippingAddressId,
        targetType: CompanyLogTargetType.SHARED_EWAYBILL_SHIPPING_ADDRESS,
      });

      return {
        total: result.totalElements,
        list: result.content,
      };
    },
    {
      defaultPageSize: 10,
    }
  );

  return (
    <Modal onCancel={onCancel} visible={visible} title="账号操作日志（操作日志保留3个月）" width={900} footer={null}>
      <Table
        loading={loading}
        rowKey="id"
        dataSource={data?.list}
        pagination={pagination}
        columns={[
          {
            title: "时间",
            dataIndex: "dateCreated",
            key: "dateCreated",
            width: 180,
          },
          {
            title: "描述",
            dataIndex: "description",
            key: "description",
          },
          {
            title: "操作人",
            dataIndex: "nickName",
            key: "nickName",
            width: 180,
          },
        ]}
      ></Table>
    </Modal>
  );
};

const LogButton: React.FC<LogButtonProps> = function (props) {
  const { shippingAddressId } = props;
  const modalStore = useModalStore();

  function handleOpenRecycleSettingModal() {
    modalStore.openModal(RecycleSettingModal, {
      shippingAddressId,
    });
  }

  return (
    <Button type="link" size="small" onClick={handleOpenRecycleSettingModal}>
      操作日志
    </Button>
  );
};

export default observer(LogButton);
